<ng-template #template>
  <div
    *ngIf="data?.items.length > 1"
    [class.sticky]="sticky"
    #stickyMenu
    id="sticky-row"
  >
    <div class="row px-0">
      <ul
        class="col sub-type"
        aria-role="tablist"
        aria-label="navigation second level tabs"
      >
        <a
          *ngFor="let itm of data?.items; let idx = index"
          class="btn btn-outline-secondary font-btn-small text-uppercase"
          [attr.aria-label]="itm.caption"
          [class.btn-outline-secondary]="
            !itm.value.startsWith(getSelectedPath())
          "
          [ngClass]="[itm.value.startsWith(getSelectedPath()) ? cssColor : '']"
          [routerLink]="['/' + getPage() + '/' + itm.value]"
          queryParamsHandling="merge"
          style="cursor: pointer"
          role="tab"
          [attr.aria-selected]="itm.value.startsWith(getSelectedPath())"
          >{{ itm.caption }}</a
        >
      </ul>
    </div>
  </div>
</ng-template>
